import { render, staticRenderFns } from "./outairdatahistory.vue?vue&type=template&id=465f6c0e&scoped=true&"
import script from "./outairdatahistory.vue?vue&type=script&lang=ts&"
export * from "./outairdatahistory.vue?vue&type=script&lang=ts&"
import style0 from "./outairdatahistory.vue?vue&type=style&index=0&id=465f6c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465f6c0e",
  null
  
)

export default component.exports